import { Link, Button } from '~/shared/components';
import styled from '@emotion/styled';
import { theme } from '~/theme';
import Favorite from '~/icons/favorit.svg';
import DeleteBasket from '~/icons/deletebasket.svg';
import { LoginButton } from '~/features/navigation/components/N20MainMenu/components/LoginButton';
import { Theme } from '@emotion/react';
import { FavWrapper } from '~/shared/components/ProductCard/components/Favourite';
import { mq } from '~/lib/helpers/media-query.helper';
import { breakpoints } from '~/theme/breakpoints';

export const StyleMainList = styled.div(() => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    '& *:focus-visible': {
        boxShadow: theme.shadows.accessibility,
    },
}));

export const StyledIndividualProduct = styled.div(() => ({
    display: 'flex',
    button: {
        flexDirection: 'row',
    },
    [breakpoints.lg]: {
        paddingRight: `${theme.space['1']}`,
    },
}));

export const StyledLoginButton = styled(LoginButton)(() => ({}));

export const StyledLinkCheckout = styled(Link)(() => ({
    color: `${theme.colors.black}`,
    textDecoration: 'underline',
    '&:hover': {
        color: `${theme.colors.black}`,
    },
}));

export const StyledProductItem = styled.div(({ theme }: { theme: Theme }) => ({
    position: 'relative',
    marginBottom: theme.space[2],
    transform: `translateY(0)`,
    '& a:hover': {
        textDecoration: 'none',
    },
    height: '100%',
    border: `1px solid ${theme?.colors.grey35}`,
    width: '100%',
    display: 'flex',
    zIndex: 1,
    transitionDuration: '150ms',
    transitionProperty: 'transform',
    transitionTimingFunction: 'ease-in',
    '&:after': {
        transitionDuration: '150ms',
        transitionProperty: 'opacity transform',
        transitionTimingFunction: 'ease-in',
        position: 'absolute',
        zIndex: -1,
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        content: '""',
        width: '100%',
        height: '100%',
        opacity: 0,
        boxShadow: theme?.shadows.productCard,
    },
    [mq(0, 'xs')]: {
        flexDirection: 'column',
    },
    [`${FavWrapper}`]: {
        right: 'auto',
        bottom: 'auto',
        padding: theme?.space[2],
        svg: {
            margin: 0,
            height: theme.space[4],
            width: theme.space[4],
        },
    },
}));

export const StyledFavIcon = styled(Favorite)({
    height: '24px',
    width: '24px',
    margin: 0,
    position: 'absolute',
    bottom: `${theme.space['1']}`,
    left: `${theme.space['1']}`,
    cursor: 'pointer',
});

export const StyledRemoveButtonWrapper = styled.div(() => ({
    gridArea: 'remove-product-button',
    display: 'flex',
    justifyContent: 'flex-end',
}));

export const StyledRemoveProduct = styled(DeleteBasket)({});

export const StyledRemoveProductButton = styled(Button)({
    display: 'flex',
    alignSelf: 'start',
    minHeight: 'unset',

    svg: {
        fill: 'currentcolor',

        '& path': {
            fill: 'currentcolor',
        },
    },
});

export const ImageWrap = styled.div(({ theme }) => ({
    height: '100%',
    width: '106px',
    background: theme.colors.productImageBackround,
    position: 'relative',
    img: {
        mixBlendMode: 'multiply',
    },

    [breakpoints.lg]: {
        height: '100%',
        width: '126px',
    },
    [mq(0, 'xs')]: {
        height: '150px',
        width: '100%',
    },
}));

export const StyledProductInfo = styled.div(() => ({
    position: 'relative',
    width: '100%',
    padding: theme.space['3'],
    display: 'grid',
    gap: theme.space['2'],
    gridTemplateColumns: '1fr auto auto',
    gridTemplateAreas: `
        'product-info-details product-info-details remove-product-button'
        'price-per-item input-stepper input-stepper'
        'product-price product-price product-price'
        `,
    justifyContent: 'space-between',

    [breakpoints.lg]: {
        rowGap: theme.space['3'],
        gridTemplateColumns: '1fr 100px 100px 50px',
        alignItems: 'center',
        gridTemplateAreas: `
                'product-info-details price-per-item input-stepper remove-product-button'
                'product-info-details product-price product-price product-price'
            `,
    },
}));

export const StyledProductInfoDetails = styled.div(() => ({
    gridArea: 'product-info-details',
    width: '100%',
}));

export const StyledProductInfoBrand = styled.span(() => ({
    display: 'block',
    paddingBottom: theme.space[2],
    fontSize: theme.fontSizes['2xs'],
    color: theme.colors.black,
    width: '100%',
}));
export const StyledProductInfoTitle = styled.p(() => ({
    color: theme.colors.black,
    fontSize: theme.fontSizes['xs'],
    paddingBottom: theme.space[2],
    lineHeight: theme.lineHeights.base,
    fontWeight: theme.fontWeights.medium,
    width: '100%',
    [breakpoints.md]: {
        fontSize: theme.fontSizes['md'],
    },
}));
export const StyledProductInfoMaterial = styled.div(() => ({
    color: theme.colors.black,
    lineHeight: theme.lineHeights.base,
    width: '100%',
    fontSize: theme.fontSizes['2xs'],
    paddingBottom: theme.space[2],
    [breakpoints.md]: {
        paddingBottom: theme.space[4],
    },
}));

export const StyledProductInfoFootnotes = styled.div(() => ({
    color: theme.colors.black,
    fontSize: theme.fontSizes['2xs'],
}));

export const StyledProductPersonalization = styled(StyledProductInfoFootnotes)(() => ({
    marginTop: '10px',
    marginBottom: '10px',

    em: { fontStyle: 'italic' },
}));

export const StyledProductInfoPrice = styled.div(() => ({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
}));

export const StyledProductInfoPricePromoQt = styled.div(() => ({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'left',
    lineHeight: theme.fontSizes['md'],
}));

export const StyledPricePerItem = styled.span(() => ({
    gridArea: 'price-per-item',
    display: 'flex',
    fontSize: theme.fontSizes['2xs'],
    alignItems: 'center',

    [breakpoints.lg]: {
        fontSize: theme.fontSizes['xs'],
        span: {
            marginLeft: 0,
        },
    },
}));

export const StyledInputStepper = styled.div(() => ({
    gridArea: 'input-stepper',
    display: 'flex',
    justifyContent: 'flex-end',
    maxWidth: theme.space[9],
}));

export const StyledProductPrice = styled.div(() => ({
    gridArea: 'product-price',
    fontSize: theme.fontSizes['2xs'],
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    width: '100%',
    marginTop: `${theme.space['2']}`,
    [breakpoints.lg]: {
        lineHeight: theme.fontSizes['xl'],
        marginTop: '0',
    },
}));

export const StyledProductCampaignText = styled.span(({ theme }) => ({
    width: '100%',
    color: `${theme.colors.redMediumLight}`,
    lineHeight: theme.fontSizes['md'],
    [breakpoints.lg]: {
        fontSize: theme.fontSizes['xs'],
    },
}));

export const StyledProductFinalPrice = styled.div(({ theme }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    gap: theme.space[2],
    lineHeight: theme.fontSizes['md'],
    fontSize: theme.fontSizes['xs'],
}));

export const StyledProductFinalPriceValue = styled.span<{ isHighlighted?: boolean }>(
    ({ theme, isHighlighted }) => ({
        fontWeight: theme.mixins.useFontWeight('Medium'),

        ...(isHighlighted && {
            color: `${theme.colors.redMediumLight}`,
        }),
    }),
);

export const StyledProductFinalPriceLabel = styled.span<{ isHighlighted?: boolean }>(
    ({ theme, isHighlighted }) => ({
        ...(isHighlighted && {
            color: `${theme.colors.redMediumLight}`,
        }),
    }),
);

export const StyledSpanStrike = styled.span(() => ({
    color: theme.colors.black70,
    textDecoration: 'line-through',
}));
